import { getSessionSaga, reduceLoading, reduceOperation } from 'metrix-common3';
import { call, put } from 'redux-saga/effects';
import { getPolicySummarySaga } from './getPolicySummarySaga';

export function* regenerateDocumentsSaga({ payload }) {
    try {
        yield put(reduceLoading({ code: 'regenerateDocuments', value: true }));
        const session = yield getSessionSaga();

        const response = yield call(fetch, '/api/document/regenerate', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });

        const result = yield call([response, 'json']);

        yield call(getPolicySummarySaga);

        yield put(reduceOperation(result.operation));
    } catch (error) {
        console.error(error);
    } finally {
        yield put(reduceLoading({ code: 'regenerateDocuments', value: false }));
    }
}
